import type { DeleteUserGroupUsersMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

type DeleteUserGroupUsersInput = {
  UserIds: string[];
  UserGroupId: string;
};

const mapTrpcResponseToGraphQL = (trpcData: {
  affected_rows: number;
}): DeleteUserGroupUsersMutation => ({
  delete_user_group_user: {
    __typename: 'user_group_user_mutation_response',
    affected_rows: trpcData.affected_rows,
  },
});

export const useDeleteUserGroupUsersTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.userGroup.deleteUsers.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.userGroup.usersByGroupId.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.userGroup.userGroupsWithApprovers.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.userGroup.userGroupById.queryKey(),
        });
      },
    }),
  });

  return {
    deleteUserGroupUsers: async (
      variables: DeleteUserGroupUsersInput
    ): Promise<DeleteUserGroupUsersMutation> => {
      const result = await mutation.mutateAsync({
        UserGroupId: variables.UserGroupId,
        UserIds: variables.UserIds,
      });

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
